module.exports = __webpack_public_path__ + "img/training-travel4.6d8246e6.jpg";